// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { MenuOutlined, CategoryOutlined, BurstModeOutlined, DoDisturbOutlined, EditNoteOutlined, Filter, AutoAwesomeMotionOutlined } from '@mui/icons-material';
import enums from 'utils/enums';

// icons
const icons = {
  MenuOutlined,
  CategoryOutlined,
  BurstModeOutlined,
  DoDisturbOutlined,
  EditNoteOutlined,
  Filter,
  AutoAwesomeMotionOutlined
};

// ==============================|| MENU ITEMS - MAIN ||============================== //
const menu = {
  id: 'mobile-application',
  type: 'group',
  title: <FormattedMessage id='application' />,
  children: [
    {
      id: 'disableditemlist',
      title: <FormattedMessage id='disabledlist' />,
      subTitle: 'Manage Disabled Items',
      type: 'item',
      url: 'mobile-application/disableditem',
      icon: icons.DoDisturbOutlined,
      isShowFilter: true,
      showTitle: true
    },
  ]
};

export default menu;
